<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        カードリーダー管理　
        <div class="headerBtn" v-if="role == 'admin'" @click="add()">新規登録</div>
        <div class="headerBtn" v-if="role == 'admin'" @click="bulkAdd()">一括登録</div>
      </div>

      <div class="row">
        <p class="inputTitle condition">機器ID</p>
        <multiselect
          v-model="deviceIdCondition"
          :options="deviceIdOptions"
          :multiple="true"
          :taggable="true"
          placeholder="検索したい機器IDを入力"
          selectLabel="選択"
          deselectLabel="解除"
          selectedLabel="選択済"
          label="name"
          track-by="code"
          style="margin: auto"
          @tag="addDeviceIdTag">
        >
        <span slot="noOptions"></span>
        </multiselect>
        <!-- 選択されたタグの情報確認用 -->
        <!-- <pre class="language-json"><code>{{ siteCondition  }}</code></pre> -->
      </div>

      <div class="row">
        <p class="inputTitle condition">事業者</p>
        <multiselect
          v-model="companyNameCondition"
          :options="companyNameOptions"
          :close-on-select="false"
          :multiple="true"
          :taggable="true"
          placeholder="検索したい事業者名を選択"
          selectLabel="選択"
          deselectLabel="解除"
          selectedLabel="選択済"
          label="companyName"
          track-by="companyId"
          style="margin: auto"
        >
        <span slot="noOptions"></span>
        </multiselect>
        <!-- 選択されたタグの情報確認用 -->
        <!-- <pre class="language-json"><code>{{ siteCondition  }}</code></pre> -->
      </div>

      <div class="searchBtn" @click="search()">検索</div>

      <!-- ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
      </div>
      <!-- APIエラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <!-- 削除エラー表示 -->
      <div v-if="deleteErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errDiv">
            データの削除中に問題が発生しました。
          </div>
        </div>
      </div>
      <!-- 現在表示件数 / 検索結果最大件数 -->
      <div style="text-align:right" v-if="!getLodingFlg && !getErrorFlg">
        <div v-if="limit * currentPage <= conditionRow.length">
          {{(limit * currentPage) - (limit - 1)}} - {{limit * currentPage}} / {{conditionRow.length}} 件
        </div>
        <div v-else>
          {{(limit * currentPage) - (limit - 1)}} - {{conditionRow.length}} / {{conditionRow.length}} 件
        </div>
      </div>
      <vue-good-table
        ref="my-table"
        :columns='columns'
        :rows='conditionRow'
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true,
          selectionText: '選択中',
          clearSelectionText: '選択を解除',
        }"
        :pagination-options="{
          enabled: true,
          perPageDropdownEnabled: false,
          mode: 'pages',
          perPage: 100,
          position: 'top',
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: '次へ',
          prevLabel: '前へ',
          rowsPerPageLabel: '表示する行数',
          ofLabel: '/',
          pageLabel: 'ページ',
          allLabel: 'All',
        }"
        :group-options="{
          enabled: false
        }"
        @on-page-change="onPageChange"
        @on-selected-rows-change="selectionChanged"
        v-if="!getLodingFlg && !getErrorFlg"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'operation'" style="display: flex;">
            <div class="edit" @click="edit(props.formattedRow.id)">編集</div>
            <div class="remove" @click="openModal(0, props.formattedRow)">削除</div>
          </span>
          <span v-else>{{props.formattedRow[props.column.field]}}</span>
          <span v-if="props.column.field === 'companyName'" style="display: flex;">
            <div class="appendId" v-if="props.formattedRow.companyId">{{props.formattedRow.companyId}}</div>
          </span>
          <span v-if="props.column.field === 'siteName'" style="display: flex;">
            <div class="appendId" v-if="props.formattedRow.ccusSiteId">{{props.formattedRow.ccusSiteId}}</div>
          </span>
        </template>
        <div slot="selected-row-actions" style="margin: auto;">
          <button class="remove" @click.stop="openModal(1)" style="line-height: 20px; margin: auto;">一括削除</button>
        </div>
        <div slot="emptystate">データがありません</div>
      </vue-good-table>
      <button type="button" class="csvBtn" @click="callOutputCsv()"
        :disabled="!csvDlFlg && conditionRow.length > csvLimit"
        v-bind:class="{
          disabled: !csvDlFlg && conditionRow.length > csvLimit,
          active: csvDlFlg && conditionRow.length <= csvLimit
        }"
      >
        表示中のデータをCSV形式でダウンロード
      </button>
      <div style="text-align:right">
        ※CSVダウンロード件数は最大{{csvLimit}}件になります。<br>
        　件数を超えている場合は検索条件にて絞り込みを行ってください。
      </div>
    </div>

    <!-- 削除モーダル画面 -->
    <Modal size="delete" @close="closeModal(0)" v-if="deleteModal">
      <!-- ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
      </div>
      <p class="modalTitle">削除しますか？</p>
      <div style="text-align:left; margin: 0px 30px 0px 30px; font-weight: bold;">
        <p>
          本当に【機器ID： {{selectRow.deviceId}} 】のカードリーダー情報を削除してもよろしいですか？<br>
          一度削除したデータは復旧出来ませんので、ご了承下さい。
        </p>
      </div>
      <button @click.once="deleteExecution(selectRow.id)" class="modalYes">削除する</button>
      <button @click="closeModal(0)" class="modalNo" style="margin: 50px 0px 0px 30px;">キャンセル</button>
    </Modal>

    <!-- 一括削除モーダル画面 -->
    <Modal size="deleteCompanySites" @close="closeModal(1)" v-if="bulkDeleteModal">
      <p class="modalTitle">カードリーダー一括削除確認</p>
        <!-- ローディング -->
        <div v-if="deleteLodingFlg">
          <vue-loading
            type="cylon"
            color="#1b7e47"
            :size="{ width: '150px', height: '150px' }"
          >
          </vue-loading>
          <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
        </div>
        <div v-if="!deleteLodingFlg">
        <div style="text-align:left; margin: 0px 30px 0px 30px; font-weight: bold;">
          <p>
            本当に以下のカードリーダー情報を削除してもよろしいですか？<br>
          </p>

        <vue-good-table
          ref="bulkDelete"
          :columns='deleteCardReaderColumns'
          :rows='deleteSelectRows'
          :select-options="{
            disableSelectInfo: true,
          }"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 5,
            position: 'bottom',
            perPageDropdownEnabled: false,
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: '次へ',
            prevLabel: '前へ',
            rowsPerPageLabel: '表示する行数',
            ofLabel: 'of',
            pageLabel: 'page',
            allLabel: 'All',
          }"
          :group-options="{
            enabled: false
          }"
        >
        <div slot="emptystate">データがありません</div>
      </vue-good-table>
      </div>
      <button @click.once="bulkDelete" class="modalYes">削除する</button>
      <button @click="closeModal(1)" class="modalNo" style="margin: 50px 0px 0px 30px;">キャンセル</button>
    </div>
    </Modal>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import '../style/vue-good-table.scss';
import { VueGoodTable } from 'vue-good-table';
import Modal from './BaseModal.vue';
import ApiClient from '../services/ApiClient';
import common from '../services/common';
import { VueLoading } from 'vue-loading-template';

// when使用のための処理 ------ start
type ChainedWhen<T, R> = {
  on: <A>(pred: (v: T) => boolean, fn: () => A) => ChainedWhen<T, R | A>;
  otherwise: <A>(fn: () => A) => R | A;
};

const match = <T, R>(val: any): ChainedWhen<T, R> => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) => match<T,  R | A>(val),
  otherwise: <A>(fn: () => A): A | R => val,
});

const chain = <T,  R>(val: T): ChainedWhen<T,  R> => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) =>
    pred(val) ? match(fn()) : chain<T,  A | R>(val),
  otherwise: <A>(fn: () => A) => fn(),
});

const when = <T>(val: T) => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) =>
    pred(val) ? match<T,  A>(fn()) : chain<T,  A>(val),
});
// when使用のための処理 ------ end

export default {
  title: 'カードリーダー一覧',
  name: 'cardReader',
  components: {
    VueGoodTable,
    Modal,
    VueLoading,
  },
  data() {
    return {
      deviceIdOptions: [],
      deviceIdCondition: [],
      companyNameOptions: [],
      companyNameCondition: [],
      deleteModal: false,
      bulkDeleteModal: false,
      getLodingFlg: false,
      deleteLodingFlg: false,
      getErrorFlg: false,
      deleteErrorFlg: false,
      csvDlFlg: false,
      errorMessage: '',
      columns: [
        {
          label: '内部ID',
          field: 'id',
          hidden: true,
        },
        {
          label: '機器ID',
          field: 'deviceId',
          sortable: true,
          width: '125px',
        },
        {
          label: '事業者',
          field: 'companyName',
          sortable: true,
          width: '200px',
        },
        {
          label: '事業者ID',
          field: 'companyId',
          hidden: true,
        },
        {
          label: '現場',
          field: 'siteName',
          sortable: true,
        },
        {
          label: '現場ID',
          field: 'ccusSiteId',
          hidden: true,
        },
        {
          label: 'モードID',
          field: 'modeId',
          hidden: true,
        },
        {
          label: 'モード',
          field: 'modeName',
          sortable: true,
          width: '80px',
        },
        {
          label: '',
          field: 'operation',
          sortable: false,
          width: '145px',
        },
      ],
      conditionRow: [],
      // 選択行のデータを詰める
      selectRow: {},
      // チェックボックス選択行データを詰める
      deleteSelectRows: [],
      displayingModal: 0,
      // 削除カードリーダーテーブル列
      deleteCardReaderColumns: [
        {
          label: '機器ID',
          field: 'deviceId',
        },
        {
          label: '現場',
          field: 'siteName',
          sortable: true,
        },
      ],
      // 検索上限
      limit: 100,
      // 検索内容最大件数
      maxCount: 0,
      // 現在ページ
      currentPage: 1,
      // 現在ページ
      inputPage: 1,
      // 最大ページ数
      maxPage: 1,
      // CSV取得上限
      csvLimit: 10000,
    };
  },
  // 初期処理
  async mounted() {
    try {
      // ローディング表示
      this.getLodingFlg = true;
      // カードリーダー一覧取得API呼出
      this.rows = await this.callGetCardReadersList();
      // 初期テーブルデータをセット
      this.conditionRow = this.rows;
      // 事業者リスト取得API呼出
      this.companyNameOptions = await this.callGetCompaniesNameList();
      // 検索条件を取得
      this.deviceIdCondition = common.getUrlParam('deviceId', 0);
      this.companyNameCondition = common.getUrlParam('companyName', 0);
      // 検索処理呼出
      this.search();
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // カードリーダー一覧取得API呼び出し
    async callGetCardReadersList() {
      try {
        const restResourceService = new ApiClient();
        const resultRows = await restResourceService.getCardReadersList();
        return resultRows;
      } catch (error) {
        this.errorMessage = error.message;
        throw error;
      }
    },
    // 事業者リスト取得API呼び出し
    async callGetCompaniesNameList() {
      try {
        switch (this.role) {
          case 'admin':
            const restResourceService = new ApiClient();
            return await restResourceService.getCompaniesNameList();
            break;
          case 'business':
            break;
          case 'branch':
            break;
          case 'worker':
            break;
          default:
            break;
        }
      } catch (error) {
        this.errorMessage = error.message;
        throw error;
      }
    },
    // 検索条件：機器ID追加
    addDeviceIdTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000)),
      };
      this.deviceIdCondition.push(tag);
      this.deviceIdOptions.push(tag);
    },
    // 検索条件：事業者追加
    addBusinessTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000)),
      };
      this.companyNameCondition.push(tag);
      this.companyNameOptions.push(tag);
    },
    // 権限によって表示列を非表示にする処理
    roleCheck(val) {
      // 運営管理者の場合は全て表示
      // computedの変数はこの時点では参照できないため、gettersで直接参照する
      if (this.$store.getters.session.role === 'admin') {
        return false;
      // 事業者・技能者の場合
      } else {
        if (val <= 1) {
          return false;
        } else {
          return true;
        }
      }
    },
    // 検索ボタン押下時
    search() {
      this.setCondition(this.rows);
      // 検索条件をURLに詰める
      common.setUrlParam('deviceId', this.deviceIdCondition, 0);
      common.setUrlParam('companyName', this.companyNameCondition, 0);
      // テーブルが空の場合CSVダウンロードを非活性
      this.csvDlFlg  = (this.conditionRow.length > 0) ? true : false;
    },
    // 一覧上部の検索条件を一覧へ反映
    setCondition(rows) {
      // 検索条件がない場合、初期データを書き戻す
      if (this.deviceIdCondition.length === 0 && this.companyNameCondition.length === 0) {
        this.conditionRow = rows;
        return;
      }
      let newRows = [];
      let tempRows = rows;
      this.conditionRow = [];
      // 検索条件：機器ID(部分一致)
      if (this.deviceIdCondition.length !== 0) {
        newRows = [];
        // 検索用タグ配列分ループ
        this.deviceIdCondition.forEach(
          (deviceId) => {
            // 表示中のテーブル列の中からタグ
            const tempRow = tempRows.filter((v) =>
              v.deviceId.match(deviceId.name),
            );
            if (tempRow.length !== 0) {
              Array.prototype.push.apply(newRows, tempRow);
            }
          },
        );
        // 重複チェック
        this.conditionRow = Array.from(
          new Map(newRows.map((row) => [row.id, row])).values()
        );
        tempRows = this.conditionRow;
      }
      // 検索条件：事業者（選択）
      if (this.companyNameCondition.length !== 0) {
        // 検索条件に合うレコードを取得
        this.conditionRow = common.searchConditionName(this.companyNameCondition, tempRows, 'companyName');
        tempRows = this.conditionRow;
      }
    },
    // カードリーダー新規登録画面へ遷移
    add() {
      this.$router.push('/cardReader/add');
    },
    // カードリーダー一括登録画面へ遷移
    bulkAdd() {
      this.$router.push('/cardReader/bulkAdd');
    },
    // カードリーダー編集画面へ遷移
    edit(params) {
      this.$router.push({
        name: 'CardReaderEdit',
        params: {
          id: params,
        },
      });
    },
    // 削除実行
    async deleteExecution(value) {
      try {
        // ローディング表示
        this.getLodingFlg = true;
        // エラーフラグ初期化
        this.deleteErrorFlg = false;
        // カードリーダ削除API呼び出し
        const restResourceService = new ApiClient();
        await restResourceService.deleteCardReader(value);
        // カードリーダ一覧再取得
        this.rows = await this.callGetCardReadersList();
        this.conditionRow = this.rows;
      } catch (error) {
        this.errorMessage = error.message;
        this.deleteErrorFlg = true;
      } finally {
        // 削除モーダルを閉じる
        this.closeModal(0);
        // ローディング非表示
        this.getLodingFlg = false;
      }
    },
    // モーダルを開く
    openModal(num, params) {
      window.history.pushState(null, null, null);
      if (num === 0) {
        this.displayingModal = 0;
        window.addEventListener('popstate', this.modalBack);
        this.selectRow = params;
        this.deleteModal = true; // 削除
      } else if (num === 1) {
        this.displayingModal = 1;
        window.addEventListener('popstate', this.modalBack);
        this.bulkDeleteModal = true; // 一括削除
      }
    },
    // モーダルを閉じる
    closeModal(num) {
      window.removeEventListener('popstate', this.modalBack);
      this.deleteModal = false;
      when(num)
        .on((v) => v === 0, () => this.deleteModal = false)        // 詳細
        .on((v) => v === 1, () => this.bulkDeleteModal = false)    // 一括削除
    },
    // モーダル表示中ブラウザバック処理
    modalBack() {
      this.closeModal(this.displayingModal);
    },
    // CSV出力用共通関数呼出
    async callOutputCsv() {
      const columns = this.columns;
      const rows = this.conditionRow;
      // ファイル名用の現在日時
      const currentDate = new Date().getTime();
      const date = await common.getToday(currentDate);
      const fileName = 'カードリーダー一覧'+date;
      common.outputCsv(columns, rows, fileName);
    },
    // チェックボックス選択行取得
    selectionChanged(checkRows) {
      this.deleteSelectRows = checkRows.selectedRows;
    },
    // チェックボックス選択行を一括削除
    async bulkDelete() {
      try {
        // ローディング表示
        this.deleteLodingFlg = true;
        // エラーフラグ初期化
        this.deleteErrorFlg = false;
        // チェックボックス選択行からIDを配列で取得する
        const cardReaders = common.getSelectRowIds(this.deleteSelectRows);
        if (cardReaders.length !== 0) {
          // カードリーダ削除API呼び出し
          const restResourceService = new ApiClient();
          await restResourceService.deleteCardReaderList(cardReaders);
          // カードリーダ一覧再取得
          this.rows = await this.callGetCardReadersList();
          this.conditionRow = this.rows;
        }
      } catch (error) {
        this.errorMessage = error.message;
        this.deleteErrorFlg = true;
      } finally {
        // 削除モーダルを閉じる
        this.closeModal(1);
        // ローディング非表示
        this.deleteLodingFlg = false;
      }
    },
    // 現在ページ更新
    onPageChange(params) {
      this.currentPage = params.currentPage;
      common.scrollTop();
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
@import "../style/variables.scss";
.modalTitle {
  margin: 30px auto;
  font-weight: bold;
  font-size: $font-medium;
  color: $font_color;
}
.modalYes {
  background-color: $button-primary;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  margin-bottom: 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
.modalNo {
  background-color: $button-danger;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
</style>
